/* Global imports */
import * as React from 'react'

import { Chip, ChipProps, styled } from '@mui/material'

/* Local imports */

/* Types  */

type KeywordProps = { sentiment?: 'positive' | 'negative' } & ChipProps
/* Local utility functions */

/* Component definition */
export const Keyword = (props: KeywordProps) => {
  return <S.Chip {...props} size="small"></S.Chip>
}

const S = {
  Chip: styled(Chip)<KeywordProps>`
    & .MuiChip-labelSmall {
      padding-left: ${(props) => props.theme.spacing(1.25)};
      padding-right: ${(props) => props.theme.spacing(1.25)};
    }
  `,
}
